import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowTrendUp, faAward, faBullhorn, faFileSignature, faKey, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";


import ServiceCard from "./ServiceCard";

const ServicesList = () => {

    const { t } = useTranslation();

    const serviesList = [
        {
            icon: <FontAwesomeIcon icon={faArrowTrendUp} />,
            title: t('servicesPage.service1.title'),
            description: t('servicesPage.service1.description'),
            btnText: t('servicesPage.service1.btnText'),
            btnLink: "/servizio/valorizza-patrimonio"
        },
        {
            icon: <FontAwesomeIcon icon={faKey} />,
            title: t('servicesPage.service2.title'),
            description: t('servicesPage.service2.description'),
            btnText: t('servicesPage.service2.btnText'),
            btnLink: "/servizio/vendita-immobili"
        },
        {
            icon: <FontAwesomeIcon icon={faMagnifyingGlass} />,
            title: t('servicesPage.service3.title'),
            description: t('servicesPage.service3.description'),
            btnText: t('servicesPage.service3.btnText'),
            btnLink: "/servizio/ricerca-immobili"
        },
        {
            icon: <FontAwesomeIcon icon={faFileSignature} />,
            title: t('servicesPage.service4.title'),
            description: t('servicesPage.service4.description'),
            btnText: t('servicesPage.service4.btnText'),
            btnLink: "/servizio/affitti-locazioni"
        },
        {
            icon: <FontAwesomeIcon icon={faBullhorn} />,
            title: t('servicesPage.service5.title'),
            description: t('servicesPage.service5.description'),
            btnText: t('servicesPage.service5.btnText'),
            btnLink: "/servizio/marketing"
        },
        {
            icon: <FontAwesomeIcon icon={faAward} />,
            title: t('servicesPage.service6.title'),
            description: t('servicesPage.service6.description'),
            btnText: t('servicesPage.service6.btnText'),
            btnLink: "/servizio/garanzia-splendida"
        }
    ]

    return (
        <div className="row">
            {serviesList.map((service, index) => (
                <div className="col-12 col-md-6 col-lg-4 mb-4" key={index}>
                    <ServiceCard service={service} />
                </div>
            ))}
        </div>
    );
}

export default ServicesList;